import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageview } from "../lib/analytics";

// Records an anonymous pageview on every public route change.
export default function AnalyticsTracker() {
  const location = useLocation();
  useEffect(() => {
    if (location.pathname.startsWith("/admin")) return;
    trackPageview(location.pathname);
  }, [location.pathname]);
  return null;
}
